module.exports = __webpack_public_path__ + "img/icon_map_37_on_110.fc76346a.png";